<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="dedicationPage_01"><p class="dedicationText"><span>To Yvonne, for all the guidance and encouragement over these many years.</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743483629_dedicationPage_01.vue?ae0571a4